import { IJobReducer } from '../../interfaces';

export const jobsInitialState:IJobReducer = {
  host: null,
  hostId: '0',
  temporaryData: null
};
